import type { FunctionComponent } from 'react';
import { resolveImagePath } from '@/utils/imageMap';

interface ExperienceBenefit {
  iconUrl: string;
  title: string;
  description: string;
}

const experienceBenefits: ExperienceBenefit[] = [
  {
    iconUrl: "https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc7908_Vectors-Wrapper.svg",
    title: "Freedom",
    description: "Give yourself the gift of travel days free from big airports, baggage carousels, or other people's schedules."
  },
  {
    iconUrl: "https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc7909_Vectors-Wrapper.svg", 
    title: "Lifestyle",
    description: "Enjoy the experience of flying rather than being herded into an aerial school bus with wings."
  },
  {
    iconUrl: "https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc790a_Vectors-Wrapper.svg",
    title: "Options", 
    description: "Learn to be your own pilot or charter a plane and arrive much closer to your destination through a wide selection of regional airports."
  },
  {
    iconUrl: "https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc790b_Vectors-Wrapper.svg",
    title: "Community",
    description: "The private aviation community is a proud group of people who have chosen their own way to fly, just like you."
  }
];

export const Experience: FunctionComponent = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left side - Content */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12">
                This Is The Private Aviation Experience
              </h2>
              
              {/* Benefits Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {experienceBenefits.map((benefit, index) => (
                  <div key={index} className="flex flex-col items-start">
                    {/* Icon */}
                    <div className="mb-4">
                      <img 
                        src={resolveImagePath(benefit.iconUrl)}
                        alt={`${benefit.title} Icon`}
                        className="w-12 h-12 object-contain"
                      />
                    </div>
                    
                    {/* Title */}
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {benefit.title}
                    </h3>
                    
                    {/* Description */}
                    <p className="text-gray-600 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Right side - Airplane Interior Image */}
            <div className="lg:pl-8">
              <img 
                src={resolveImagePath("https://cdn.prod.website-files.com/64fa264c1f05b9ea79dc792b/64fa264c1f05b9ea79dc796f_2023.08.21_CA-ContentDay_TV-1602-p-1600.jpg")}
                alt="Woman inside a private charter airplane about to take flight at Crystal Air in Chattanooga, Tennessee"
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};